__turbopack_context__.v({
  "actions": "Hero-module__BQPb0G__actions",
  "container": "Hero-module__BQPb0G__container",
  "copy": "Hero-module__BQPb0G__copy",
  "definition": "Hero-module__BQPb0G__definition",
  "definitionKicker": "Hero-module__BQPb0G__definitionKicker",
  "definitionQuestion": "Hero-module__BQPb0G__definitionQuestion",
  "definitionRow": "Hero-module__BQPb0G__definitionRow",
  "headline": "Hero-module__BQPb0G__headline",
  "headlineWrap": "Hero-module__BQPb0G__headlineWrap",
  "hero": "Hero-module__BQPb0G__hero",
  "line": "Hero-module__BQPb0G__line",
  "noWrap": "Hero-module__BQPb0G__noWrap",
  "pen": "Hero-module__BQPb0G__pen",
  "penArrow": "Hero-module__BQPb0G__penArrow",
  "penDraw": "Hero-module__BQPb0G__penDraw",
  "penText": "Hero-module__BQPb0G__penText",
  "penWrite": "Hero-module__BQPb0G__penWrite",
  "term": "Hero-module__BQPb0G__term",
});
